/**
 * Clean-room constants inspired by endless-runner motor declarations
 * (speed ramp, 3 lanes, chunk cleanup). Units remapped for three.js comfort.
 * Not copied from proprietary SYBO assets or method bodies.
 */
export const CONFIG = {
  lanes: 3,
  laneWidth: 2.2,
  laneXs: [-2.2, 0, 2.2],

  // Mapped from DefaultInitialSpeed≈110 → DefaultTargetSpeed≈220
  initialSpeed: 12,
  targetSpeed: 24,
  speedRampDistance: 1800, // distance over which speed approaches target

  jumpHeight: 2.35,
  jumpDuration: 0.55,
  rollDuration: 0.55,
  laneChangeDuration: 0.18,

  playerCapsuleHeight: 1.7,
  playerCapsuleRadius: 0.35,
  rollHeightScale: 0.45,

  chunkLength: 40,
  chunksAhead: 6,
  cleanupDistance: 300,

  coinValue: 1,
  magnetDuration: 8,
  magnetRadius: 6,
  hoverboardDuration: 5,

  gravityFeel: 1.0,
};

export const ObstacleKind = {
  BARRIER_LOW: 'barrier_low',   // roll under
  BARRIER_HIGH: 'barrier_high', // jump over
  TRAIN: 'train',               // jump onto / avoid (hit if same lane standing)
  TRAIN_GAP: 'train_gap',       // side gap — must change lane
};

export const PickupKind = {
  COIN: 'coin',
  MAGNET: 'magnet',
  HOVERBOARD: 'hoverboard',
};
